/**
 * ApexCharts writes series names into the DOM with `innerHTML` (legend text, tooltip
 * label), so any server-written string passed as a series name must be HTML-escaped
 * first: night titles and stage names are typed by `night:manage` holders.
 * Apex then parses the entities back, so a title with `&` still reads `&` on screen
 * and `<img onerror=…>` shows as literal text instead of running.
 */
export function escapeChartText(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
